module.exports = __webpack_public_path__ + "static/media/open_newbill.852ee467.svg";